import { Component, HostListener, OnInit } from '@angular/core';
import { Event as NavigationEvent, NavigationEnd, Router } from '@angular/router';
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../services/auth/auth.service";
import { KeyValue } from "@angular/common";
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { selectFirstNameFromToken, selectLastSigninTimestampFromToken } from "../../stores/auth/auth.selector";
import { AppState } from "../../stores/app.state";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  title: string = 'Driving Record and Insurance History';

  tabs = {
    home: { viewValue: 'Home', routePath: '/' },
    account: { viewValue: 'Account', routePath: '/account' },
    claims: { viewValue: 'Claims', routePath: '/claims' },
    dl: { viewValue: 'Driver licensing & ID', routePath: '/driver-licensing' },
    insurance: { viewValue: 'Insurance & registration', routePath: '/insurance' },
    support: { viewValue: 'Help & support', routePath: '/help-and-support' },
  }
  keepOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => 0;

  // oauthToken$!: Observable<OauthToken>;
  readonly firstName = this.store.selectSignal(selectFirstNameFromToken);
  readonly lastSigninTimestamp = this.store.selectSignal(selectLastSigninTimestampFromToken);

  private lastScrollTop = 0;
  isOverlayOpen = false;
  isHeaderHidden = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<AppState>,
    private analytics: AnalyticsService
  ) {
  }

  ngOnInit(): void {
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd && event.urlAfterRedirects.includes('cardstatus')) {
        this.title = 'Has my card been mailed?'
      }
    });

    // this.oauthToken$ = this.store.select('oauthTokenReducer');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    this.isHeaderHidden = currentScroll > this.lastScrollTop && currentScroll > 50;
    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  trackClick(linkUrl: string, linkText: string, navigationType: string) {
    this.analytics.sendNavigationEvent(linkUrl, linkText, navigationType);
  }

  onLogoClick(): void {
    const url = `${environment.portalHomeUrl}`;
    this.trackClick(url, 'icbc_logo', 'global_header');
    window.location.href = url;
  }

  onMyICBCClick(): void {
    const url = `${environment.portalHomeUrl}`;
    this.trackClick(url, 'My ICBC', 'global_header');
    window.location.href = url;
  }

  routeTo(tabRef: string, tabText: string): void {
    const url = `${environment.portalHomeUrl}` + tabRef;
    this.trackClick(url, tabText, 'global_header');
    window.location.href = url;
  }

  onPplIconClick(): void {
    this.trackClick('', 'ppl_icon', 'global_header');
  }

  signOut(): void {
    const url = environment.oauth2SignOutUrl;
    this.trackClick(url, 'Sign out', 'global_header_ppl_icon');
    this.authService.signOut();
  }

  onManageAccountClick(): void {
    const url = `${environment.portalHomeUrl}${this.tabs.account.routePath}`;
    this.trackClick(url, 'Manage account settings', 'global_header_ppl_icon');
    window.location.href = url;
  }

  onReturnToICBCClick(ICBCUrl: string): void {
    this.trackClick(ICBCUrl, 'Return to icbc.com', 'global_header_ppl_icon');
    window.location.href = ICBCUrl;
  }

  protected readonly environment = environment;
}
